const asamCriteriaJSON = {
  section: 'AC',
  topic: 'ASAM Criteria',
  checked: 'true',
  // access: "private",
  color: 'secondary',
  description: '(optional)',
  body: [
    {
      id: 'AC.V',
      shortname: 'ac00',
      name: 'Version of ASAM',
      prevalue: '',
      value: '',
      disabled: 'false',
      type: 'radio',
      radio_options: ['3th Edition', '4th Edition'],
      act: 'AC00',
      mandatory: 'true',
      depending: '',
      exception: '',
    },
    {
      id: 'AC.1',
      shortname: 'ac01-v4',
      name: 'Intoxication, Withdrawal, and Addiction Medications',
      prevalue: '',
      value: '',
      disabled: 'true',
      type: 'select',
      ruletype: 'string',
      select_options: [
        '',
        '0: Non-issue or very low-risk issue.',
        '1: Mildly difficult issue or present minor signs and symptoms.',
        '2: Moderate difficulty in functioning.',
        '3: Serious issue or difficulty coping within a given dimension.',
        '4: Indicates utmost severity; critical impairments in coping and functioning.',
      ],
      act: 'AC01-V4',
      mandatory: 'true',
      depending: 'AC00',
      exception: '4th Edition',
      link: 'AC01-1-V4',
    },
    {
      id: 'AC.1.1',
      shortname: 'ac01-1-v4',
      name: '',
      prevalue: 'Justification for the selected rating:',
      value: '',
      disabled: 'true',
      type: 'editor',
      act: 'AC01-1-V4',
      mandatory: 'true',
      depending: 'AC01-V4',
      exception: '',
      extend: 'true',
    },
    {
      id: 'AC.2',
      shortname: 'ac02-v4',
      name: 'Biomedical Conditions',
      prevalue: '',
      value: '',
      disabled: 'true',
      type: 'select',
      ruletype: 'string',
      select_options: [
        '',
        '0: Non-issue or very low-risk issue.',
        '1: Mildly difficult issue or present minor signs and symptoms.',
        '2: Moderate difficulty in functioning.',
        '3: Serious issue or difficulty coping within a given dimension.',
        '4: Indicates utmost severity; critical impairments in coping and functioning.',
      ],
      act: 'AC02-V4',
      mandatory: 'true',
      depending: 'AC00',
      exception: '4th Edition',
      link: 'AC02-1-V4',
    },
    {
      id: 'AC.2.1',
      shortname: 'ac02-1-v4',
      name: '',
      prevalue: 'Justification for the selected rating:',
      value: '',
      disabled: 'true',
      type: 'editor',
      act: 'AC02-1-V4',
      mandatory: 'true',
      depending: 'AC02-V4',
      exception: '',
      extend: 'true',
    },
    {
      id: 'AC.3',
      shortname: 'ac03-v4',
      name: 'Psychiatric and Cognitive Conditions',
      prevalue: '',
      value: '',
      disabled: 'true',
      type: 'select',
      ruletype: 'string',
      select_options: [
        '',
        '0: Non-issue or very low-risk issue.',
        '1: Mildly difficult issue or present minor signs and symptoms.',
        '2: Moderate difficulty in functioning.',
        '3: Serious issue or difficulty coping within a given dimension.',
        '4: Indicates utmost severity; critical impairments in coping and functioning.',
      ],
      act: 'AC03-V4',
      mandatory: 'true',
      depending: 'AC00',
      exception: '4th Edition',
      link: 'AC03-1-V4',
    },
    {
      id: 'AC.3.1',
      shortname: 'ac03-1-v4',
      name: '',
      prevalue: 'Justification for the selected rating:',
      value: '',
      disabled: 'true',
      type: 'editor',
      act: 'AC03-1-V4',
      mandatory: 'true',
      depending: 'AC03-V4',
      exception: '',
      extend: 'true',
    },
    {
      id: 'AC.4',
      shortname: 'ac04-v4',
      name: 'Substance Use-Related Risks',
      prevalue: '',
      value: '',
      disabled: 'true',
      type: 'select',
      ruletype: 'string',
      select_options: [
        '',
        '0: Non-issue or very low-risk issue.',
        '1: Mildly difficult issue or present minor signs and symptoms.',
        '2: Moderate difficulty in functioning.',
        '3: Serious issue or difficulty coping within a given dimension.',
        '4: Indicates utmost severity; critical impairments in coping and functioning.',
      ],
      act: 'AC04-V4',
      mandatory: 'true',
      depending: 'AC00',
      exception: '4th Edition',
      link: 'AC04-1-V4',
    },
    {
      id: 'AC.4.1',
      shortname: 'ac04-1-v4',
      name: '',
      prevalue: 'Justification for the selected rating:',
      value: '',
      disabled: 'true',
      type: 'editor',
      act: 'AC04-1-V4',
      mandatory: 'true',
      depending: 'AC04-V4',
      exception: '',
      extend: 'true',
    },
    {
      id: 'AC.5',
      shortname: 'ac05-v4',
      name: 'Recovery Environment Interactions',
      prevalue: '',
      value: '',
      disabled: 'true',
      type: 'select',
      ruletype: 'string',
      select_options: [
        '',
        '0: Non-issue or very low-risk issue.',
        '1: Mildly difficult issue or present minor signs and symptoms.',
        '2: Moderate difficulty in functioning.',
        '3: Serious issue or difficulty coping within a given dimension.',
        '4: Indicates utmost severity; critical impairments in coping and functioning.',
      ],
      act: 'AC05-V4',
      mandatory: 'true',
      depending: 'AC00',
      exception: '4th Edition',
      link: 'AC05-1-V4',
    },
    {
      id: 'AC.5.1',
      shortname: 'ac05-1-v4',
      name: '',
      prevalue: 'Justification for the selected rating:',
      value: '',
      disabled: 'true',
      type: 'editor',
      act: 'AC05-1-V4',
      mandatory: 'true',
      depending: 'AC05-V4',
      exception: '',
      extend: 'true',
    },
    {
      id: 'AC.6',
      shortname: 'ac06-v4',
      name: 'Person-Centered Considerations',
      prevalue: '',
      value: '',
      disabled: 'true',
      type: 'select',
      ruletype: 'string',
      select_options: [
        '',
        '0: Non-issue or very low-risk issue.',
        '1: Mildly difficult issue or present minor signs and symptoms.',
        '2: Moderate difficulty in functioning.',
        '3: Serious issue or difficulty coping within a given dimension.',
        '4: Indicates utmost severity; critical impairments in coping and functioning.',
      ],
      act: 'AC06-V4',
      mandatory: 'true',
      depending: 'AC00',
      exception: '4th Edition',
      link: 'AC06-1-V4',
    },
    {
      id: 'AC.6.1',
      shortname: 'ac06-1-v4',
      name: '',
      prevalue: 'Justification for the selected rating:',
      value: '',
      disabled: 'true',
      type: 'editor',
      act: 'AC06-1-V4',
      mandatory: 'true',
      depending: 'AC06-V4',
      exception: '',
      extend: 'true',
    },
    //========================================================================================
    /*                                                                                      *
     *                                          V3                                          *
     *                                                                                      */
    //========================================================================================

    {
      id: 'AC.1',
      shortname: 'ac01',
      name: '1 – Acute Intoxication and/or Withdrawal Potential',
      prevalue: '',
      value: '',
      disabled: 'true',
      type: 'select',
      ruletype: 'string',
      select_options: [
        '',
        '0: No withdrawal.',
        '1: Minimal Risk of severe withdrawal (ASAM Level 2.1).',
        '2: Moderate risk of severe withdrawal (ASAM Level 2.5).',
        '3: No withdrawal risk, or minimal or stable withdrawal (ASAM Level 3.1).',
        '4: At minimal risk of severe withdrawal (ASAM Level 3.3 or 3.5).',
        '5: ASAM LEVEL 3.7 ONLY: Patient has the potential for life threatening withdrawal (must meet at least two of the six dimensions, at least one of which is within dimension 1, 2, or 3).',
        '6: ASAM LEVEL 4.0 ONLY: Patient has life threatening withdrawal symptoms, possible or experiencing seizures or DT’s or other adverse reactions are imminent.',
      ],
      act: 'AC01',
      mandatory: 'true',
      depending: 'AC00',
      exception: '3th Edition',
      link: 'AC01-1',
    },

    {
      id: 'AC.1.1',
      shortname: 'ac01-1',
      name: '',
      prevalue: 'Justification for the selected rating:',
      value: '',
      disabled: 'true',
      type: 'editor',
      // type: 'text',
      act: 'AC01-1',
      mandatory: 'true',
      depending: 'AC01',
      exception: '',
      extend: 'true',
    },
    {
      id: 'AC.2',
      shortname: 'ac02',
      name: '2 – Biomedical Conditions and Complications',
      prevalue: '',
      value: '',
      disabled: 'true',
      type: 'select',
      ruletype: 'string',
      select_options: [
        '',
        '0: None or not sufficient to distract from treatment (ASAM Level 2.1 or 2.5).',
        '1: None/stable or receiving concurrent treatment – moderate stability (3.1, 3.3, 3.5).',
        '2: Require 24-hour medical monitoring, but not intensive treatment (3.7).',
        '3: ASAM LEVEL 4.0 ONLY: Severe instability requires 24-hour medical care in licensed medical facility. May be the result of life threatening withdrawal or other co-morbidity.',
      ],
      act: 'AC02',
      mandatory: 'true',
      depending: 'AC00',
      exception: '3th Edition',
      link: 'AC02-1',
    },

    {
      id: 'AC.2.1',
      shortname: 'ac02-1',
      name: '',
      prevalue: 'Justification for the selected rating:',
      value: '',
      disabled: 'true',
      type: 'editor',
      act: 'AC02-1',
      mandatory: 'true',
      depending: 'AC02',
      exception: '',
      extend: 'true',
    },
    {
      id: 'AC.3',
      shortname: 'ac03',
      name: '3 – Emotional, Behavioral, or Cognitive Conditions and Complications',
      prevalue: '',
      value: '',
      disabled: 'true',
      type: 'select',
      ruletype: 'string',
      select_options: [
        '',
        '0: None or very stable (ASAM Level 1.0).',
        '1: Mild severity, with potential to distract from recovery; needs monitoring (ASAM Level 2.1).',
        '2: Mild to moderate severity; with potential to distract from recovery; needs to stabilize (ASAM Level 2.5).',
        '3: None or minimal; not distracting to recovery (ASAM Level 3.1).',
        '4: Mild to moderate severity; needs structure to focus on recovery (ASAM Level 3.3).',
        '5: Demonstrates repeated inability to control impulses, or unstable with symptoms requiring stabilization (ASAM Level 3.5).',
        '6: Moderate severity needs 24-hour structured setting (ASAM Level 3.7).',
        '7: Severely unstable requires 24-hour psychiatric care (ASAM Level 4.0).'
      ],
      act: 'AC03',
      mandatory: 'true',
      depending: 'AC00',
      exception: '3th Edition',
      link: 'AC03-1',
    },
    {
      id: 'AC.3.1',
      shortname: 'ac03-1',
      name: '',
      prevalue: 'Justification for the selected rating:',
      value: '',
      disabled: 'true',
      type: 'editor',
      act: 'AC03-1',
      mandatory: 'true',
      depending: 'AC03',
      exception: '',
      extend: 'true',
    },
    {
      id: 'AC.4',
      shortname: 'ac04',
      name: '4 – Readiness to Change',
      prevalue: '',
      value: '',
      disabled: 'true',
      type: 'select',
      ruletype: 'string',
      select_options: [
        '',
        '0: Readiness for recovery but needs motivating and monitoring strategies to strengthen readiness, or needs ongoing monitoring and disease management (ASAM Level 1.0).',
        '1: Has variable engagement in treatment, lack of awareness of the seriousness of substance use and/or coexisting mental health problems. Requires treatment several times per week to promote change (ASAM Level 2.1).',
        '2: Has variable engagement in treatment, lack of awareness of the seriousness of substance use and/or coexisting mental health problems. Requires treatment almost daily to promote change (ASAM Level 2.5).',
        '3: Open to recovery but requires structured environment (ASAM Level 3.1).',
        '4: Has little awareness of need for change due to cognitive limitations and addiction and requires interventions to engage to stay in treatment (ASAM Level 3.3).',
        '5: Has marked difficulty with treatment or opposition due to functional issues or ongoing dangerous consequences (ASAM Level 3.5).',
        '6: Poor impulse control, continues to use substances despite severe negative consequences and requires a 24-hour structured setting (ASAM Level 3.7).'
      ],
      act: 'AC04',
      mandatory: 'true',
      depending: 'AC00',
      exception: '3th Edition',
      link: 'AC04-1',
    },

    {
      id: 'AC.4.1',
      shortname: 'ac04-1',
      name: '',
      prevalue: 'Justification for the selected rating:',
      value: '',
      disabled: 'true',
      type: 'editor',
      act: 'AC04-1',
      mandatory: 'true',
      depending: 'AC04',
      exception: '',
      extend: 'true',
    },
    {
      id: 'AC.5',
      shortname: 'ac05',
      name: '5 – Relapse, Continued Use, or Continued Problem Potential',
      prevalue: '',
      value: '',
      disabled: 'true',
      type: 'select',
      ruletype: 'string',
      select_options: [
        '',
        '0: Minimal support required to control use, needs support to change behaviors (ASAM Level 1.0).',
        '1: High likelihood of relapse/continued use or addictive behaviors, requires services several times per week (ASAM Level 2.1).',
        '2: Intensification of addiction and/or mental health issues; has not responded to active treatment in lower levels of care. High likelihood of relapse, requires treatment almost daily to promote change (ASAM Level 2.5).',
        '3: Understands relapse but needs structure (ASAM Level 3.1).',
        '4: Has little awareness of need for change due to cognitive limitations and addiction and requires interventions to engage to stay in treatment (ASAM Level 3.3).',
        '5: Does not recognize the severity of treatment issues, has cognitive and functional deficits (ASAM Level 3.5).',
        '6: Unable to control use, requires 24-hour supervision, imminent dangerous consequences (ASAM Level 3.7).'
      ],
      act: 'AC05',
      mandatory: 'true',
      depending: 'AC00',
      exception: '3th Edition',
      link: 'AC05-1',
    },
    {
      id: 'AC.5.1',
      shortname: 'ac05-1',
      name: '',
      prevalue: 'Justification for the selected rating:',
      value: '',
      disabled: 'true',
      type: 'editor',
      act: 'AC05-1',
      mandatory: 'true',
      depending: 'AC05',
      exception: '',
      extend: 'true',
    },
    {
      id: 'AC.6',
      shortname: 'ac06',
      name: '6 – Recovery/Living Environment',
      prevalue: '',
      value: '',
      disabled: 'true',
      type: 'select',
      ruletype: 'string',
      select_options: [
        '',
        '0: Supportive recovery environment and patient has skills to cope with stressors (ASAM Level 1.0).',
        '1: Not a fully supportive environment but patient has some skills to cope (ASAM Level 2.1).',
        '2: Not a supportive environment but can find outside supportive environment (ASAM Level 2.5).',
        '3: Environment is dangerous, patient needs 24-hour structure to learn to cope (ASAM Level 3.1 or 3.3).',
        '4: Environment is imminently dangerous, patient lacks skills to cope outside of a highly structured environment (ASAM Level 3.5 or 3.7).'
      ],
      act: 'AC06',
      mandatory: 'true',
      depending: 'AC00',
      exception: '3th Edition',
      link: 'AC06-1',
    },
    {
      id: 'AC.6.1',
      shortname: 'ac06-1',
      name: '',
      prevalue: 'Justification for the selected rating:',
      value: '',
      disabled: 'true',
      type: 'editor',
      act: 'AC06-1',
      mandatory: 'true',
      depending: 'AC06',
      exception: '',
      extend: 'true',
    },

    //-----------------------------------------------------------------------------------------
    // {
    //   id: "AC.1",
    //   shortname: "ac01",
    //   name: "1 – Acute Intoxication and/or Withdrawal Potential",
    //   prevalue: "",
    //   value: "",
    //   disabled: "true",
    //   type: "select",
    //   ruletype: "string",
    //   select_options: [
    //     "",
    //     "0: Non-issue or very low-risk issue.",
    //     "1: Mildly difficult issue or present minor signs and symptoms.",
    //     "2: Moderate difficulty in functioning.",
    //     "3: Serious issue or difficulty coping within a given dimension.",
    //     "4: Indicates utmost severity; critical impairments in coping and functioning.",
    //   ],
    //   act: "AC01",
    //   mandatory: "true",
    //   depending: "AC00",
    //   exception: "3th Edition",
    //   link: "AC01-1",
    // },
    // {
    //   id: "AC.1.1",
    //   shortname: "ac01-1",
    //   name: "",
    //   prevalue: "Justification for the selected rating:",
    //   value: "",
    //   disabled: "true",
    //   type: "editor",
    //   act: "AC01-1",
    //   mandatory: "true",
    //   depending: "AC01",
    //   exception: "",
    //   extend: "true",
    // },
    // {
    //   id: "AC.2",
    //   shortname: "ac02",
    //   name: "2 – Biomedical Conditions and Complications",
    //   prevalue: "",
    //   value: "",
    //   disabled: "true",
    //   type: "select",
    //   ruletype: "string",
    //   select_options: [
    //     "",
    //     "0: Non-issue or very low-risk issue.",
    //     "1: Mildly difficult issue or present minor signs and symptoms.",
    //     "2: Moderate difficulty in functioning.",
    //     "3: Serious issue or difficulty coping within a given dimension.",
    //     "4: Indicates utmost severity; critical impairments in coping and functioning.",
    //   ],
    //   act: "AC02",
    //   mandatory: "true",
    //   depending: "AC00",
    //   exception: "3th Edition",
    //   link: "AC02-1",
    // },
    // {
    //   id: "AC.2.1",
    //   shortname: "ac02-1",
    //   name: "",
    //   prevalue: "Justification for the selected rating:",
    //   value: "",
    //   disabled: "true",
    //   type: "editor",
    //   act: "AC02-1",
    //   mandatory: "true",
    //   depending: "AC02",
    //   exception: "",
    //   extend: "true",
    // },
    // {
    //   id: "AC.3",
    //   shortname: "ac03",
    //   name:
    //     "3 – Emotional, Behavioral, or Cognitive Conditions and Complications",
    //   prevalue: "",
    //   value: "",
    //   disabled: "true",
    //   type: "select",
    //   ruletype: "string",
    //   select_options: [
    //     "",
    //     "0: Non-issue or very low-risk issue.",
    //     "1: Mildly difficult issue or present minor signs and symptoms.",
    //     "2: Moderate difficulty in functioning.",
    //     "3: Serious issue or difficulty coping within a given dimension.",
    //     "4: Indicates utmost severity; critical impairments in coping and functioning.",
    //   ],
    //   act: "AC03",
    //   mandatory: "true",
    //   depending: "AC00",
    //   exception: "3th Edition",
    //   link: "AC03-1",
    // },
    // {
    //   id: "AC.3.1",
    //   shortname: "ac03-1",
    //   name: "",
    //   prevalue: "Justification for the selected rating:",
    //   value: "",
    //   disabled: "true",
    //   type: "editor",
    //   act: "AC03-1",
    //   mandatory: "true",
    //   depending: "AC03",
    //   exception: "",
    //   extend: "true",
    // },
    // {
    //   id: "AC.4",
    //   shortname: "ac04",
    //   name: "4 – Readiness to Change",
    //   prevalue: "",
    //   value: "",
    //   disabled: "true",
    //   type: "select",
    //   ruletype: "string",
    //   select_options: [
    //     "",
    //     "0: Non-issue or very low-risk issue.",
    //     "1: Mildly difficult issue or present minor signs and symptoms.",
    //     "2: Moderate difficulty in functioning.",
    //     "3: Serious issue or difficulty coping within a given dimension.",
    //     "4: Indicates utmost severity; critical impairments in coping and functioning.",
    //   ],
    //   act: "AC04",
    //   mandatory: "true",
    //   depending: "AC00",
    //   exception: "3th Edition",
    //   link: "AC04-1",
    // },
    // {
    //   id: "AC.4.1",
    //   shortname: "ac04-1",
    //   name: "",
    //   prevalue: "Justification for the selected rating:",
    //   value: "",
    //   disabled: "true",
    //   type: "editor",
    //   act: "AC04-1",
    //   mandatory: "true",
    //   depending: "AC04",
    //   exception: "",
    //   extend: "true",
    // },
    // {
    //   id: "AC.5",
    //   shortname: "ac05",
    //   name: "5 – Relapse, Continued Use, or Continued Problem Potential",
    //   prevalue: "",
    //   value: "",
    //   disabled: "true",
    //   type: "select",
    //   ruletype: "string",
    //   select_options: [
    //     "",
    //     "0: Non-issue or very low-risk issue.",
    //     "1: Mildly difficult issue or present minor signs and symptoms.",
    //     "2: Moderate difficulty in functioning.",
    //     "3: Serious issue or difficulty coping within a given dimension.",
    //     "4: Indicates utmost severity; critical impairments in coping and functioning.",
    //   ],
    //   act: "AC05",
    //   mandatory: "true",
    //   depending: "AC00",
    //   exception: "3th Edition",
    //   link: "AC05-1",
    // },
    // {
    //   id: "AC.5.1",
    //   shortname: "ac05-1",
    //   name: "",
    //   prevalue: "Justification for the selected rating:",
    //   value: "",
    //   disabled: "true",
    //   type: "editor",
    //   act: "AC05-1",
    //   mandatory: "true",
    //   depending: "AC05",
    //   exception: "",
    //   extend: "true",
    // },
    // {
    //   id: "AC.6",
    //   shortname: "ac06",
    //   name: "6 – Recovery/Living Environment",
    //   prevalue: "",
    //   value: "",
    //   disabled: "true",
    //   type: "select",
    //   ruletype: "string",
    //   select_options: [
    //     "",
    //     "0: Non-issue or very low-risk issue.",
    //     "1: Mildly difficult issue or present minor signs and symptoms.",
    //     "2: Moderate difficulty in functioning.",
    //     "3: Serious issue or difficulty coping within a given dimension.",
    //     "4: Indicates utmost severity; critical impairments in coping and functioning.",
    //   ],
    //   act: "AC06",
    //   mandatory: "true",
    //   depending: "AC00",
    //   exception: "3th Edition",
    //   link: "AC06-1",
    // },
    // {
    //   id: "AC.6.1",
    //   shortname: "ac06-1",
    //   name: "",
    //   prevalue: "Justification for the selected rating:",
    //   value: "",
    //   disabled: "true",
    //   type: "editor",
    //   act: "AC06-1",
    //   mandatory: "true",
    //   depending: "AC06",
    //   exception: "",
    //   extend: "true",
    // },
  ],
};

export default asamCriteriaJSON;
